import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./index.module.css";
export const TopbarButton = ({ title = "", isActive = false, handleClick, isDisabled = false, children }) => {
    return (_jsx("button", Object.assign({ className: `
        ${styles['topbar-button']}
        ${isActive ? styles['active'] : ''}
      `, onClick: (e) => handleClick(e), title: title, "aria-label": title, disabled: isDisabled }, { children: children })));
};
